import { IN_USE, DRAFT, PUBLISHED, ARCHIVED } from '@innovatrix/constants';

export const statusMapping = {
  [IN_USE]: 'In use',
  [DRAFT]: 'Draft',
  [PUBLISHED]: 'Published',
  [ARCHIVED]: 'Archived',
};
